import React, { useState, useEffect } from "react";
import axios from "axios";
import { Table, Spinner, ButtonGroup, Button, Form } from "react-bootstrap";
import { FaStar, FaRegStar, FaSearch } from "react-icons/fa";

const CryptoMarket = () => {
  const [coinList, setCoinList] = useState(["KRW-1INCH", "KRW-A", "KRW-AAVE", "KRW-ADA", "KRW-AERGO", "KRW-AGLD", "KRW-AHT", "KRW-AKT", "KRW-ALGO", "KRW-ALT", "KRW-ANIME", "KRW-ANKR", "KRW-APT", "KRW-AQT", "KRW-ARB", "KRW-ARDR", "KRW-ARK", "KRW-ARKM", "KRW-ASTR", "KRW-ATH", "KRW-ATOM", "KRW-AUCTION", "KRW-AVAX", "KRW-AWE", "KRW-AXL", "KRW-AXS", "KRW-BAT", "KRW-BCH", "KRW-BEAM", "KRW-BERA", "KRW-BIGTIME", "KRW-BLAST", "KRW-BLUR", "KRW-BONK", "KRW-BORA", "KRW-BOUNTY", "KRW-BSV", "KRW-BTC", "KRW-BTT", "KRW-CARV", "KRW-CBK", "KRW-CELO", "KRW-CHZ", "KRW-CKB", "KRW-COMP", "KRW-COW", "KRW-CRO", "KRW-CTC", "KRW-CVC", "KRW-CYBER", "KRW-DEEP", "KRW-DKA", "KRW-DOGE", "KRW-DOT", "KRW-DRIFT", "KRW-EGLD", "KRW-ELF", "KRW-ENA", "KRW-ENS", "KRW-ERA", "KRW-ETC", "KRW-ETH", "KRW-FCT2", "KRW-FIL", "KRW-FLOW", "KRW-G", "KRW-GAME2", "KRW-GAS", "KRW-GLM", "KRW-GMT", "KRW-GRS", "KRW-GRT", "KRW-HBAR", "KRW-HIVE", "KRW-HP", "KRW-HUNT", "KRW-HYPER", "KRW-ICX", "KRW-ID", "KRW-IMX", "KRW-INJ", "KRW-IOST", "KRW-IOTA", "KRW-IP", "KRW-IQ", "KRW-JST", "KRW-JTO", "KRW-JUP", "KRW-KAITO", "KRW-KAVA", "KRW-KNC", "KRW-LAYER", "KRW-LINK", "KRW-LPT", "KRW-LSK", "KRW-MANA", "KRW-MASK", "KRW-MBL", "KRW-ME", "KRW-MED", "KRW-META", "KRW-MEW", "KRW-MINA", "KRW-MLK", "KRW-MNT", "KRW-MOC", "KRW-MOCA", "KRW-MOODENG", "KRW-MOVE", "KRW-MTL", "KRW-MVL", "KRW-NEAR", "KRW-NEO", "KRW-NEWT", "KRW-NXPC", "KRW-OM", "KRW-OMNI", "KRW-ONDO", "KRW-ONG", "KRW-ONT", "KRW-OP", "KRW-ORBS", "KRW-ORCA", "KRW-PENDLE", "KRW-PENGU", "KRW-PEPE", "KRW-POKT", "KRW-POL", "KRW-POLYX", "KRW-POWR", "KRW-PROVE", "KRW-PUNDIX", "KRW-PYTH", "KRW-QKC", "KRW-QTUM", "KRW-RAY", "KRW-RENDER", "KRW-RVN", "KRW-SAFE", "KRW-SAHARA", "KRW-SAND", "KRW-SC", "KRW-SEI", "KRW-SHIB", "KRW-SIGN", "KRW-SNT", "KRW-SOL", "KRW-SONIC", "KRW-SOPH", "KRW-STEEM", "KRW-STG", "KRW-STORJ", "KRW-STRAX", "KRW-STRIKE", "KRW-STX", "KRW-SUI", "KRW-SXP", "KRW-SYRUP", "KRW-T", "KRW-TAIKO", "KRW-TFUEL", "KRW-THETA", "KRW-TIA", "KRW-TOKAMAK", "KRW-TRUMP", "KRW-TRX", "KRW-TT", "KRW-UNI", "KRW-USDC", "KRW-USDT", "KRW-UXLINK", "KRW-VANA", "KRW-VET", "KRW-VIRTUAL", "KRW-VTHO", "KRW-W", "KRW-WAL", "KRW-WAVES", "KRW-WAXP", "KRW-WCT", "KRW-XEC", "KRW-XLM", "KRW-XRP", "KRW-XTZ", "KRW-ZETA", "KRW-ZIL", "KRW-ZRO", "KRW-ZRX"]);
  const [prices, setPrices] = useState({});
  const [loading, setLoading] = useState(true);
  const [sortBy, setSortBy] = useState("volume");
  const [sortOrder, setSortOrder] = useState("desc");
  const [clickedCoins, setClickedCoins] = useState(
    JSON.parse(localStorage.getItem("clickedCoins") || "[]")
  );
  const [viewMode, setViewMode] = useState("all"); // all or favorite
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    const fetchMarketData = async () => {
      try {
        const response = await axios.get("https://api.upbit.com/v1/market/all");
        const krwMarkets = response.data
          .filter((market) => market.market.startsWith("KRW-"))
          .map((market) => market.market);
        setCoinList(krwMarkets);
        setLoading(false);
      } catch (error) {
        console.error("코인 목록 가져오기 실패:", error);
        setLoading(false);
      }
    };

    fetchMarketData();
  }, []);
  /*
    useEffect(() => {
      if (coinList.length === 0) return;
      const ws = new WebSocket("wss://api.upbit.com/websocket/v1");
  
      ws.onopen = () => {
        const subscribeMsg = [
          { ticket: "crypto-market" },
          { type: "ticker", codes: coinList },
        ];
        ws.send(JSON.stringify(subscribeMsg));
      };
  
      ws.onmessage = async (event) => {
        const data = await event.data.text();
        const json = JSON.parse(data);
        setPrices((prevPrices) => ({
          ...prevPrices,
          [json.code]: {
            name: json.code.replace("KRW-", ""),
            price: json.trade_price,
            change: json.signed_change_rate * 100,
            volume: Math.round(json.acc_trade_price_24h / 100000000),
          },
        }));
      };
  
      return () => ws.close();
    }, [coinList]);
  */
  useEffect(() => {
    if (coinList.length === 0) return;

    let ws;

    const connectWebSocket = () => {
      ws = new WebSocket("wss://api.upbit.com/websocket/v1");

      ws.onopen = () => {
        const subscribeMsg = [
          { ticket: "crypto-market" },
          { type: "ticker", codes: coinList },
        ];
        ws.send(JSON.stringify(subscribeMsg));
      };

      ws.onmessage = async (event) => {
        const data = await event.data.text();
        const json = JSON.parse(data);
        setPrices((prevPrices) => ({
          ...prevPrices,
          [json.code]: {
            name: json.code.replace("KRW-", ""),
            price: json.trade_price,
            change: json.signed_change_rate * 100,
            volume: Math.round(json.acc_trade_price_24h / 100000000),
          },
        }));
      };

      ws.onerror = (e) => {
        console.error("WebSocket error:", e);
      };

      ws.onclose = (e) => {
        console.warn("WebSocket closed. Reconnecting...", e.reason);
        setTimeout(connectWebSocket, 3000); // 3초 후 재연결
      };
    };

    connectWebSocket();

    return () => {
      if (ws) ws.close();
    };
  }, [coinList]); // 배열 내용이 바뀌었을 때만 재연결

  const getSortIcon = (key) => {
    if (sortBy !== key) return "";
    return sortOrder === "asc" ? "▲" : sortOrder === "desc" ? "▼" : "";
  };

  const handleSort = (key) => {
    if (sortBy === key) {
      setSortOrder(sortOrder === "asc" ? "desc" : sortOrder === "desc" ? "default" : "asc");
    } else {
      setSortBy(key);
      setSortOrder("asc");
    }
  };

  const handleCoinClick = (coinName) => {
    const updatedClickedCoins = clickedCoins.includes(coinName)
      ? clickedCoins.filter((c) => c !== coinName)
      : [...clickedCoins, coinName];

    setClickedCoins(updatedClickedCoins);
    localStorage.setItem("clickedCoins", JSON.stringify(updatedClickedCoins));
  };

  const handleViewModeChange = (mode) => {
    setViewMode(mode);
  };

  const sortedData = Object.values(prices)
    .filter((coin) =>
      viewMode === "favorite" ? clickedCoins.includes(coin.name) : true
    )
    .filter((coin) =>
      coin.name.toLowerCase().includes(searchQuery.toLowerCase())
    )
    .sort((a, b) => {
      if (sortOrder === "default") return 0;
      if (sortOrder === "asc") return a[sortBy] > b[sortBy] ? 1 : -1;
      if (sortOrder === "desc") return a[sortBy] < b[sortBy] ? 1 : -1;
      return 0;
    });

  return (
    <div className="crypto-card-container py-4" style={{ maxWidth: 480 }}>
      <div className="crypto-card">
        <h5 className="fw-bold text-center mb-3">🪙 업비트 실시간 시세 조회</h5>

        {/* 검색창 */}
        <div className="crypto-search-wrapper">
          <FaSearch className="crypto-search-icon" />
          <Form.Control
            type="text"
            placeholder="코인명 검색 (예: BTC, ETH)"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="crypto-search-input"
          />
        </div>

        {/* 탭 버튼 그룹 */}
        <ButtonGroup className="w-100 mb-3" style={{ borderRadius: '10px', overflow: 'hidden' }}>
          <Button
            variant={viewMode === "all" ? "primary" : "outline-primary"}
            onClick={() => handleViewModeChange("all")}
            style={{ fontSize: '0.85rem', fontWeight: 600 }}
          >
            전체 코인
          </Button>
          <Button
            variant={viewMode === "favorite" ? "primary" : "outline-primary"}
            onClick={() => handleViewModeChange("favorite")}
            style={{ fontSize: '0.85rem', fontWeight: 600 }}
          >
            ⭐ 즐겨찾기 ({clickedCoins.length})
          </Button>
        </ButtonGroup>

        {loading ? (
          <div className="text-center my-4">
            <Spinner animation="border" variant="primary" />
          </div>
        ) : (
          <div className="crypto-table-wrapper">
            <Table hover size="sm" className="crypto-table">
              <thead>
                <tr>
                  <th onClick={() => handleSort("name")} style={{ cursor: "pointer", width: '30%' }}>
                    {getSortIcon("name")} 코인
                  </th>
                  <th onClick={() => handleSort("price")} style={{ cursor: "pointer", textAlign: "right" }}>
                    {getSortIcon("price")} 현재가
                  </th>
                  <th onClick={() => handleSort("change")} style={{ cursor: "pointer", textAlign: "right", width: '28%' }}>
                    {getSortIcon("change")} 대비
                  </th>
                  <th onClick={() => handleSort("volume")} style={{ cursor: "pointer", textAlign: "right" }}>
                    {getSortIcon("volume")} 거래량
                  </th>
                </tr>
              </thead>
              <tbody>
                {sortedData.length === 0 ? (
                  <tr>
                    <td colSpan="4" className="text-center text-muted py-4">조회된 코인이 없습니다.</td>
                  </tr>
                ) : (
                  sortedData.map((coin) => {
                    const isFav = clickedCoins.includes(coin.name);
                    return (
                      <tr key={coin.name}>
                        <td>
                          <div className="d-flex align-items-center gap-2">
                            <button
                              className={`crypto-star-btn ${isFav ? 'active' : ''}`}
                              onClick={() => handleCoinClick(coin.name)}
                            >
                              {isFav ? <FaStar /> : <FaRegStar />}
                            </button>
                            <span className="fw-bold text-dark">{coin.name}</span>
                          </div>
                        </td>
                        <td className="text-end font-monospace">
                          {coin.price?.toLocaleString() || "..."}
                        </td>
                        <td className="text-end">
                          <span className={`crypto-premium-capsule ${coin.change >= 0 ? 'positive' : 'negative'}`} style={{ border: 'none', padding: '3px 8px', fontSize: '0.75rem' }}>
                            {coin.change > 0
                              ? `+${coin.change.toFixed(2)}%`
                              : `${coin.change?.toFixed(2)}%`}
                          </span>
                        </td>
                        <td className="text-end font-monospace text-secondary" style={{ fontSize: '0.8rem' }}>
                          {coin.volume.toLocaleString()}억
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </Table>
          </div>
        )}
      </div>
    </div>
  );
};

export { CryptoMarket };
